import axios from '@store/axios'
import parseUrl from '@/core/helpers/parseUrl'
import each from 'lodash/each'
import dateFormat from 'date-fns/format'

const MED_SEARCH_URL =
  'https://clinicaltables.nlm.nih.gov/api/rxterms/v3/search?terms&maxList'
const PROB_SEARCH_URL =
  'https://clinicaltables.nlm.nih.gov/api/conditions/v3/search?terms&maxList'

export default {
  clearPatient({ commit }) {
    commit('setPatient', {})
  },
  getPatients({ commit }) {
    const url = parseUrl('/patients')
    return axios.get(url).then(({ data }) => {
      data.forEach(patient => {
        patient.fullName = patient.firstName + ' ' + patient.lastName
        let d = new Date(patient.birthdate * 1000)
        patient.birthdateString = ('0' + (d.getMonth() + 1)).slice(-2) + '/' + ('0' + d.getDate()).slice(-2) + '/' + d.getFullYear()
      })
      commit('setPatients', data)
      return data
    })
  },
  getPatientsGQL({ commit }, {offset, order}) {
    let queryParameters = 'offset: ' + offset + ', limit: 10, order: ' + '"' + order + '"'
    let query = '{ patients( ' + queryParameters + ' ) { data { id birthdate gender firstName lastName } pageInfo { count offset next } }}'
    commit('setSearchTermLastName', null)
    commit('setSearchTermFirstName', null)
    commit('setSearchTermBirthdate', null)
    commit('setSearchOrder', order)
    return axios.post('/gql', { query }).then(({ data }) => {
      console.log(data.data.patients.data)
      console.log(data.data.patients.pageInfo)
      commit('setPatients', data.data.patients.data)
      commit('setPatientsOffset', data.data.patients.pageInfo.offset)
      commit('setPatientsCount', data.data.patients.pageInfo.count)
      commit('setPatientsNext', data.data.patients.pageInfo.next)
      return data.data.patients.data
    })
  },
  getPatientsGQLSearch({ commit }, { firstName, lastName, birthdate, offset, order }) {
    let lastSearchTerm = '"' + lastName + '"'
    let firstSearchTerm = '"' + firstName + '"'

    let queryParameters = 'offset: ' + offset + ', limit: 10, order: ' + '"' + order + '"'

    commit('setSearchOrder', order)

    if (lastName) {
      queryParameters += ', lastName: ' + lastSearchTerm
      commit('setSearchTermLastName', lastName)
    } else {
      commit('setSearchTermLastName', null)
    }

    if (firstName) {
      queryParameters += ', firstName: ' + firstSearchTerm
      commit('setSearchTermFirstName', firstName)
    } else {
      commit('setSearchTermFirstName', null)
    }

    if (birthdate) {
      queryParameters += ', birthdate: ' + birthdate
      commit('setSearchTermBirthdate', birthdate)
    } else {
      commit('setSearchTermBirthdate', null)
    }

    let query = '{ patients( ' + queryParameters + ' ) { data { id birthdate gender firstName lastName } pageInfo { count offset next } }}'

    return axios.post('/gql', { query }).then(({ data }) => {
      console.log(data.data.patients.data)
      console.log(data.data.patients.pageInfo)
      commit('setPatients', data.data.patients.data)
      commit('setPatientsOffset', data.data.patients.pageInfo.offset)
      commit('setPatientsCount', data.data.patients.pageInfo.count)
      commit('setPatientsNext', data.data.patients.pageInfo.next)
      return data.data.patients.data
    })
  },
  setThePatient({ commit }, patient) {
    commit('setPatient', patient)
    return patient
  },
  getPatient({ commit }, { id }) {
    const url = parseUrl('/patients/:id', { id })
    axios.get(url).then(({ data }) => {
      commit('setPatient', data)
      return data
    })
  },
  getSharedFiles({ commit }, { id }) {
    const url = parseUrl('/shares/:id', { id })
    axios.get(url).then(({ data }) => {
      commit('setSharedFilesExpiration', data.share.expiration)
      commit('setPatient', data.patients[0])
      each(data.files, item => {
        console.log('files being set')
        const ts = new Date(parseInt(item._id.substr(0, 8), 16) * 1000)
        item.created = dateFormat(ts, 'MMM D YYYY')
        item.createdTimestamp = ts.getTime() / 1000
        item.rawTimestampForSorting = item.createdTimestamp
        if (item.encounterDate) {
          item.rawTimestampForSorting = item.encounterDate
        }
      })
      commit('setFiles', data.files)
      console.log(data.files)
      return data.files
    })
  },
  getFiles({ commit }, { id }) {
    const url = parseUrl('/patients/:id/files', { id })
    return axios.get(url).then(({ data }) => {
      each(data, item => {
        const ts = new Date(parseInt(item._id.substr(0, 8), 16) * 1000)
        item.created = dateFormat(ts, 'MMM D YYYY')
        item.createdTimestamp = ts.getTime() / 1000
        item.rawTimestampForSorting = item.createdTimestamp
        if (item.encounterDate) {
          item.rawTimestampForSorting = item.encounterDate
        }
      })
      commit('setFiles', data)
      return data
    })
  },
  createPatient({ commit }, patient) {
    return axios.post('/patient', patient).then(({ data }) => {
      console.log('create patient return')
      console.log(data)
      commit('setPatient', data)
      return data
    })
  },
  applySharingCode({ commit }, id) {
    console.log('sharing code pre')
    console.log(id)
    const url = parseUrl('/shares/:id/apply', id)
    return axios.post(url).then(({ data }) => {
      console.log('sharing code return')
      console.log(data)
      return data
    })
  },
  applySharingCodeToUserGroup({ commit }, { id, ID }) {
    console.log('sharing code pre')
    console.log(id)
    let payload = {}
    payload['userGroup'] = ID
    console.log(payload)
    const url = parseUrl('/shares/:id/apply', {id: id})
    return axios.post(url, payload).then(({ data }) => {
      console.log('sharing code return')
      console.log(data)
      return data
    })
  },
  createPatientWithProvider({ commit }, { patientID, id, code }) {
    // /partner/:id/sponsor
    const url = parseUrl('/partner/:id/sponsor', { id })
    let payload = {}
    payload['patient'] = patientID
    payload['sponsorCode'] = code
    return axios.post(url, payload).then(({ data }) => {
      commit('setPatient', data)
      return data
    })
  },
  getPendingRequests({ commit }, { id }) {
    const url = parseUrl('/patients/:id/requests', { id })
    return axios.get(url).then(({ data }) => {
      each(data, item => {
        const ts = new Date(parseInt(item._id.substr(0, 8), 16) * 1000)
        item.created = dateFormat(ts, 'MMM D YYYY')
      })

      let filtered = []
      data.forEach(request => {
        if (request.status !== 'CANCELLED' && request.status !== 'COMPLETED') {
          filtered.push(request)
        }
      })

      commit('setRequests', filtered)
      return filtered
    })
  },
  getPublicUploadLink({ commit }, { id }) {
    const url = parseUrl('/patients/:id/upload_url', { id })
    return axios.get(url).then(({ data }) => {
      commit('setExternalUploadLink', data.shortURL)
    })
  },
  updatePatient({ commit }, { id, payload }) {
    const url = parseUrl('/patients/:id', { id })
    return axios.patch(url, payload)
  },
  lookupMedication({ commit }, { terms }) {
    const url = parseUrl(MED_SEARCH_URL, { terms, maxList: 5 })

    return axios.get(url).then(({ data }) => {
      let searchResults = data[1]

      commit('setMedResults', searchResults)
      return searchResults
    })
  },
  lookupProblem({ commit }, { terms }) {
    const url = parseUrl(PROB_SEARCH_URL, { terms, maxList: 5 })

    return axios.get(url).then(({ data }) => {
      let searchResults = data[3]
      let place = 0

      each(data[3], item => {
        searchResults[place] = item[0]
        place = place + 1
      })

      commit('setProbResults', searchResults)
      return searchResults
    })
  },
  updatePatientMedications({ commit }, { patientId, medicationList }) {
    const url = parseUrl('/patients/:id', { id: patientId })
    return axios.patch(url, { medications: medicationList })
  },
  updatePatientAllergies({ commit }, { patientId, allergyList }) {
    const url = parseUrl('/patients/:id', { id: patientId })
    return axios.patch(url, { allergies: allergyList })
  },
  updatePatientProblems({ commit }, { patientId, problemList }) {
    const url = parseUrl('/patients/:id', { id: patientId })
    return axios.patch(url, { problems: problemList })
  },
  getPermissions({ commit }, { id }) {
    // TODO: Change to acls
    const url = parseUrl('/patients/:id/acls', { id })
    return axios.get(url).then(({ data }) => {
      let users = []
      // let userGroups = []
      // Setting users
      data.forEach(item => {
        if (item.user) {
          users.push({ user: item.user, permissions: item.allow })
        } else if (item.userGroup) {
          users.push({ group: item.userGroup, permissions: item.allow })
        }
      })

      commit('setPermissions', users)
      // commit('setUserGroupsPermissions', userGroups)
      return data
    })
  },
  updateIndividualPermissions({ commit }, { id, payload }) {
    const url = parseUrl('/patients/:id/acls', { id })
    return axios.patch(url, payload)
  },
  getPreliminaryPermissions({ commit }, { id }) {
    const url = parseUrl('/patients/:id/acls/user', { id })
    return axios
      .get(url)
      .then(({ data }) => {
        commit('setPreliminaryPermissions', data)
        return data
      })
      .catch(error => {
        let msg = {
          error: error
        }
        return msg
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/patient/actions.js